/**
 * Created by Damian on 2017-10-09.
 */

import React, { Component } from 'react';

export class IconArrow extends Component{
  render(){
    return(
      <span className={"Icons IconDown " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.modeDisabled ? 'IconsModeDisabled ' : ' ') + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 59.3 27.9">
          <path fill="none" stroke="#000000" strokeWidth="3.9211" strokeLinecap="round" d="M57.3,2L36.4,22.9c0,0-6.7,6.7-13.5,0L2,2"/>
          </svg>

      </span>
    )
  }
}


export class IconArrowHorizontal extends Component{
  render(){
    return(
      <span className={"Icons IconArrowHorizontal " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 59.3 27.9">
          <path fill="none" stroke="#000000" strokeWidth="3.9211" strokeLinecap="round" d="M57.3,2L36.4,22.9c0,0-6.7,6.7-13.5,0L2,2"/>
          </svg>
      </span>
    )
  }
}


export class IconLayout extends Component{
  render(){
    return(
      <span className={"Icons IconLayout " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 64 64" >
        <g>
          <path fill="none" d="M59.1,12.7l-9.5-5.5c-0.3-0.2-1.8-0.9-2.8,0.7L29.6,37.7L28.1,56c5.7-3.7,13.5-9.1,14.4-10.7l17.4-29.9
            C60.1,15,60.7,13.6,59.1,12.7z"/>
          <path d="M60,11.1l-9.5-5.5c-1.4-0.8-3.9-1-5.3,1.4L27.8,36.9c-0.1,0.1-0.1,0.3-0.1,0.4l-1.6,20.4c0,0.4,0.1,0.7,0.5,0.9
            c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4,0,0.5-0.1c1.5-1,15-9.7,16.6-12.3l17.4-29.9c0.1-0.1,0.8-1.5,0.4-3C61.6,12.4,61,11.7,60,11.1z
             M59.8,15.5L42.5,45.3c-0.9,1.6-8.7,7-14.4,10.7l1.4-18.3L46.8,8c0.9-1.6,2.5-0.9,2.8-0.7l9.5,5.5C60.7,13.6,60.1,15,59.8,15.5z"/>
        </g>
        <path d="M28,45.2l-1.1,12c0,0,4.8-3.3,10-6.8c0,0-2.2-1.2-3.5-2C32.6,47.8,28,45.2,28,45.2L28,45.2z"/>
        <path fill="none" stroke="#000000" strokeWidth="1.8712" d="M57.6,21.4l-14.7-8.9 M43.5,45.9L28.8,37"/>
        <line fill="none" stroke="#000000" strokeWidth="1.8713" strokeLinecap="round" strokeLinejoin="round" x1="26.8" y1="58" x2="2.9" y2="58"/>
        </svg>
      </span>
    )
  }
}

export class IconEye extends Component{
  render(){
    return(
      <span className={"Icons IconEye " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.modeDisabled ? 'IconsModeDisabled ' : ' ') + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 60 38.3" >
        <path fill="none" stroke="#000000" strokeWidth="1.7025" d="M30,37.4c16.1,0,29.1-10.8,29.1-18.3c0-7.4-13.1-18.3-29.1-18.3
          S0.9,11.7,0.9,19.1C0.9,26.6,13.9,37.4,30,37.4L30,37.4z"/>
        <g>
          <path fill="none" d="M36.1,15c0-1.1-0.9-2.1-2.1-2.1C33,13,32,13.9,32,15c0,1.1,0.9,2.1,2.1,2.1C35.2,17.1,36.1,16.2,36.1,15z"/>
          <path d="M39.9,16.8c-0.9-3.8-3.9-6.7-7.6-7.6c-2.5,0.8-4.4,3.1-4.4,5.9c0,3.4,2.8,6.1,6.1,6.1C36.9,21.2,39.2,19.3,39.9,16.8z
             M32,15c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1c0,1.1-0.9,2.1-2.1,2.1C33,17.1,32,16.2,32,15z"/>
        </g>
        <path fill="none" stroke="#000000" strokeWidth="1.7025" d="M30,29.5c5.7,0,10.4-4.6,10.4-10.4S35.7,8.8,30,8.8
          c-5.7,0-10.4,4.6-10.4,10.4S24.3,29.5,30,29.5L30,29.5z"/>
        </svg>
      </span>
    )
  }
}

export class IconProducts extends Component{
  render(){
    return(
      <span className={"Icons IconProducts " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg x="0px" y="0px" viewBox="0 0 55.6 60">
        <path fill="none" stroke="#000000" strokeWidth="1.7278" d="M10.8,12.5c0,0-7.2,0-7.7,7.2L0.9,52c0,0-0.5,7.2,6.7,7.2H48
	c0,0,7.2,0,6.7-7.2l-2.3-32.3c0,0-0.5-7.2-7.7-7.2H10.8L10.8,12.5z"/>
        <path fill="none" stroke="#000000" strokeWidth="1.7278" strokeLinecap="round" strokeLinejoin="round" d="M20.6,21.2V6.9
	c0,0,0-6,7.6-6c6.8,0,6.8,6,6.8,6v14.4"/>
      </svg>
      </span>
    )
  }
}

export class IconPlus extends Component{
  render(){
    return(
      <span className={"Icons IconPlus " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60 60">
        <path fill="none" stroke="#000000" strokeWidth="1.875" d="M59.1,30c0-16.1-13-29.1-29.1-29.1C13.9,0.9,0.9,13.9,0.9,30
          c0,16.1,13,29.1,29.1,29.1C46.1,59.1,59.1,46.1,59.1,30L59.1,30z"/>
        <path fill="none" stroke="#000000" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" d="M18.2,30h23.7 M30,18.2
          v23.7"/>
        </svg>
      </span>
    )
  }
}

export class IconClose extends Component{
  render(){
    return(
      <span className={"Icons IconClose " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 56 56" >
        <path fill="none" stroke="#000000" strokeWidth="1.8" d="M55.1,28C55.1,13,42.9,0.9,28,0.9C13,0.9,0.9,13,0.9,28
          c0,15,12.1,27.1,27.1,27.1C42.9,55.1,55.1,42.9,55.1,28L55.1,28z"/>
        <path fill="none" stroke="#000000" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" d="M17,28H39 M28,17V39"/>
        </svg>
      </span>
    )
  }
}


export class IconMinus extends Component{
  render(){
    return(
      <span className={"Icons IconMinus " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60 60" >
          <path fill="none" stroke="#000000" strokeWidth="1.875" d="M59.1,30c0-16.1-13-29.1-29.1-29.1C13.9,0.9,0.9,13.9,0.9,30
          c0,16.1,13,29.1,29.1,29.1C46.1,59.1,59.1,46.1,59.1,30L59.1,30z"/>
          <line fill="none" stroke="#000000" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" x1="18.2" y1="30" x2="41.8" y2="30"/>
        </svg>
      </span>
    )
  }
}



export class IconImageAdd extends Component{
  render(){
    return(
      <span className={"Icons IconImageAdd " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>

           <svg x="0px" y="0px" viewBox="0 0 60 32.4">
              <g>
                <path fill="none" stroke="#000000" strokeWidth="1.1955" strokeLinecap="round" strokeLinejoin="round" d="M47.8,26h11.6
                   M53.6,20.2v11.6"/>
                <path fill="none" stroke="#000000" strokeWidth="1.1955" d="M7.5,0.6c0,0-6.9,0-6.9,6.9v17.4c0,0,0,6.9,6.9,6.9h27.7
                  c0,0,6.9,0,6.9-6.9V7.5c0,0,0-6.9-6.9-6.9H7.5L7.5,0.6z"/>
                <path fill="none" stroke="#000000" strokeWidth="1.1955" strokeLinecap="round" strokeLinejoin="round" d="M0.7,22.6
                  c0,0,4.9-7.9,15.1-7.9c10.3,0,15.1,7.9,26.1,7.9"/>
                <path fill="none" stroke="#000000" strokeWidth="1.1955" d="M32.7,13.5c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7
                  c-1.5,0-2.7,1.2-2.7,2.7C30,12.3,31.2,13.5,32.7,13.5L32.7,13.5z"/>
              </g>
            </svg>


      </span>
    )
  }
}



export class IconTextAdd extends Component{
  render(){
    return(
      <span className={"Icons IconTextAdd " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 44.9">
        <path d="M22.7,37.7V2.3h4c7.8,0,9.7,1.5,11.2,8.8h1.1L38.5,0H0.4L0,11.1h1.1c1.5-7.3,3.4-8.8,11.2-8.8h4v34.6c0,5.2-0.3,6.9-6.5,7.2
          v0.7h19.4v-0.7C23.5,43.9,22.7,42.4,22.7,37.7L22.7,37.7z"/>
        <path fill="none" stroke="#000000" strokeWidth="1.7308" strokeLinecap="round" strokeLinejoin="round" d="M42.4,35.6h16.7
           M50.8,27.3V44"/>
        </svg>
      </span>
    )
  }
}



export class IconFill extends Component{
  render(){
    return(
      <span className={"Icons IconFill " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 50.2" >
          <path fill="none" stroke="#000000" strokeWidth="1.679" strokeLinecap="round" strokeLinejoin="round" d="M8.7,16.5l-6.1,6.1
            c0,0-3.9,3.9,0,7.9l17.1,17.1c0,0,3.9,3.9,7.9,0l21.8-21.8l-25-25L12,13.3"/>
          <path fill="none" stroke="#000000" strokeWidth="1.679" d="M28.6,20.6c-5.8-0.3-13.1-0.7-17.6-3.1C6.5,15.2,1,8.6,11.2,3.9
            c5.4-2.5,11.8-1.5,11.8-1.5"/>
          <path d="M27.1,22.1c0.8,0.8,2.2,0.8,3.1,0c0.8-0.8,0.8-2.2,0-3.1c-0.8-0.8-2.2-0.8-3.1,0C26.2,19.9,26.2,21.2,27.1,22.1L27.1,22.1z"
          />
          <path fill="none" stroke="#000000" strokeWidth="1.679" strokeLinecap="round" strokeLinejoin="round" d="M35.2,11.6
            C43,19.4,50,19.8,55.3,25c5.4,5.4,5.5,28.3-1.4,21.2c-5.8-5.9,2.6-13.2-4.7-20.5"/>
        </svg>
      </span>
    )
  }
}


export class IconBasket extends Component{
  render(){
    return(
      <span className={"Icons IconBasket " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>

        <svg
          x="0px" y="0px" width="58.017px" height="59.957px" viewBox="0 0 58.017 59.957" >
<polyline fill="none" stroke="#000000" strokeWidth="1.8735" strokeLinecap="round" strokeLinejoin="round" points="
	43.955,20.057 37.898,26.114 31.842,20.057 "/>
<polyline fill="none" stroke="#000000" strokeWidth="1.8735" strokeLinecap="round" strokeLinejoin="round" points="
	57.08,18.952 48.229,41.679 24.616,41.679 "/>
<polyline fill="none" stroke="#000000" strokeWidth="1.8735" strokeLinecap="round" strokeLinejoin="round" points="16.03,10.1
	26.652,51.415 51.15,51.415 "/>
<polyline fill="none" stroke="#000000" strokeWidth="1.8735" strokeLinecap="round" strokeLinejoin="round" points="
	24.419,42.564 13.798,1.249 2.577,1.249 "/>
<path d="M2.7,5.399c1.491,0,2.7-1.209,2.7-2.7c0-1.491-1.209-2.7-2.7-2.7S0,1.209,0,2.7C0,4.191,1.209,5.399,2.7,5.399L2.7,5.399z"
/>
<path fill="none" stroke="#000000" strokeWidth="1.8735" strokeLinejoin="round" d="M46.267,59.02
	c2.005,0,3.637-1.631,3.637-3.636c0-2.005-1.631-3.636-3.637-3.636c-2.005,0-3.636,1.631-3.636,3.636
	C42.631,57.389,44.262,59.02,46.267,59.02L46.267,59.02z M31.22,59.02c2.005,0,3.636-1.631,3.636-3.636
	c0-2.005-1.631-3.636-3.636-3.636c-2.005,0-3.636,1.631-3.636,3.636C27.584,57.389,29.215,59.02,31.22,59.02L31.22,59.02z"/>
</svg>
      </span>
    )
  }
}


export class IconImage extends Component{
  render(){
    return(
      <span className={"Icons IconImage " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60.1 45.6" >
          <path fill="none" stroke="#000000" strokeWidth="1.6838" d="M10.5,0.8c0,0-9.7,0-9.7,9.7V35c0,0,0,9.7,9.7,9.7h39
            c0,0,9.7,0,9.7-9.7V10.5c0,0,0-9.7-9.7-9.7H10.5L10.5,0.8z"/>
          <path fill="none" stroke="#000000" strokeWidth="1.6838" strokeLinecap="round" strokeLinejoin="round" d="M1,31.9
            c0,0,6.8-11.1,21.3-11.1c14.5,0,21.3,11.1,36.8,11.1"/>
          <path fill="none" stroke="#000000" strokeWidth="1.6838" d="M46.1,19.1c2.1,0,3.9-1.7,3.9-3.9c0-2.1-1.7-3.9-3.9-3.9
            c-2.1,0-3.9,1.7-3.9,3.9C42.2,17.4,44,19.1,46.1,19.1L46.1,19.1z"/>
        </svg>
      </span>
    )
  }
}


export class IconText extends Component{
  render(){
    return(
      <span className={"Icons IconText " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg x="0px" y="0px" viewBox="0 0 52 59.9" >
        <g>
          <path d="M30.3,50.3V3h5.4c10.4,0,13,2,14.9,11.7H52L51.5,0h-51L0,14.8h1.4C3.5,5,6,3,16.4,3h5.4v46.3c0,6.9-0.4,9.2-8.6,9.7v0.9h26
            V59C31.4,58.7,30.3,56.7,30.3,50.3L30.3,50.3z"/>
        </g>
        </svg>
      </span>
    )
  }
}


export class IconTransform extends Component{
  render(){
    return(
      <span className={"Icons IconTransform " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg x="0px" y="0px" viewBox="0 0 60.1 60.1" >
        <path fill="none" stroke="#000000" strokeWidth="1.9238" d="M50,1V10h9.1V1H50L50,1z M50,50v9.1h9.1V50H50L50,50z M1,1V10H10V1H1
          L1,1z M1,50v9.1H10V50H1L1,50z M30,9.1c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6C26.4,7.5,28,9.1,30,9.1
          L30,9.1z M30,58.2c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6C26.4,56.6,28,58.2,30,58.2L30,58.2z M54.6,33.7
          c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6C50.9,32,52.6,33.7,54.6,33.7L54.6,33.7z M5.5,33.7
          c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6C1.9,32,3.5,33.7,5.5,33.7L5.5,33.7z M26.3,5.7H10.2 M5.7,34.2v16.1
           M26.3,54.8H10.2 M54.8,34.2v16.1 M50.3,5.7H33.5 M5.7,10.2v16.8 M50.3,54.8H33.5 M54.8,10.2v16.8"/>
        </svg>
      </span>
    )
  }
}



export class IconAdjustment extends Component{
  render(){
    return(
      <span className={"Icons IconAdjustment " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>

        <svg x="0px" y="0px" viewBox="0 0 60 56.7" >
        <path fill="none" stroke="#000000" strokeWidth="2.085" strokeLinecap="round" strokeLinejoin="round" d="M1,8.7h33.6 M59,28.4
          H25.3 M1,48.1h33.6 M51.1,8.7H59 M8.9,28.4H1 M51.1,48.1H59 M42.8,16.3c4.2,0,7.6-3.4,7.6-7.6C50.4,4.5,47,1,42.8,1
          c-4.2,0-7.6,3.4-7.6,7.6C35.2,12.9,38.6,16.3,42.8,16.3L42.8,16.3z M17.2,36c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6
          s7.6,3.4,7.6,7.6C24.8,32.6,21.4,36,17.2,36L17.2,36z M42.8,55.7c4.2,0,7.6-3.4,7.6-7.6c0-4.2-3.4-7.6-7.6-7.6
          c-4.2,0-7.6,3.4-7.6,7.6C35.2,52.3,38.6,55.7,42.8,55.7L42.8,55.7z"/>
        </svg>

      </span>
    )
  }
}




export class IconLayers extends Component{
  render(){
    return(
      <span className={"Icons IconLayers " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 60 54.2" >
        <path fill="none" stroke="#000000" strokeWidth="1.751" strokeLinecap="round" strokeLinejoin="round" d="M30,0.9L0.9,17.4L30,34
          l29.1-16.6L30,0.9L30,0.9z M0.9,28.6L30,43.7l29.1-15.1 M0.9,38.2L30,53.3l29.1-15.1"/>
        </svg>
      </span>
    )
  }
}



export class IconTrash extends Component{
  render(){
    return(
      <span className={"Icons IconTrash " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 57.5 60">
          <path fill="none" stroke="#000000" strokeWidth="1.932" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
            M7.3,8.5h40.4V59H7.3V8.5L7.3,8.5z M17.4,1h20.2v7.6H17.4V1L17.4,1z M1,8.5h55.5 M17.4,17.4v30.3 M27.5,17.4v30.3 M37.6,17.4v30.3"
          />
       </svg>
      </span>
    )
  }
}



export class IconTextAdd2 extends Component{
  render(){
    return(
      <span className={"Icons IconTextAdd2 " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60 57.2" >
          <g>
            <path fill="#646464" d="M49.7,32.2h0.2v-26c0,0,0-1.5-0.8-3.1C48.4,1.5,46.8,0,43.8,0H6.2c0,0-1.5,0-3.1,0.8C1.5,1.5,0,3.1,0,6.2
              v35c0,0,0,1.5,0.8,3.1c0.8,1.5,2.3,3.1,5.4,3.1h29v-9.1c0-2.9,1.4-4.4,2.9-5.1c0.7-0.4,1.5-0.5,2-0.6c0.3,0,0.5-0.1,0.7-0.1
              c0.2,0,0.2,0,0.2,0h8.9v-0.2H49.7V32H41c0,0-1.5,0-3.1,0.8c-1.5,0.8-3.1,2.4-3.1,5.4v8.7H6.2c-2.9,0-4.3-1.4-5.1-2.9
              c-0.4-0.7-0.5-1.5-0.6-2c0-0.3-0.1-0.5-0.1-0.7c0-0.2,0-0.2,0-0.2v-35c0-2.9,1.4-4.3,2.9-5.1c0.7-0.4,1.5-0.5,2-0.6
              c0.3,0,0.5-0.1,0.7-0.1c0.2,0,0.2,0,0.2,0h37.6c2.9,0,4.3,1.4,5.1,2.9c0.4,0.7,0.5,1.5,0.6,2c0,0.3,0.1,0.5,0.1,0.7
              c0,0.2,0,0.2,0,0.2v26H49.7V32V32.2L49.7,32.2z"/>
            <path fill="#646464" d="M41,32.2v-0.1c0,0-1.5,0-3.1,0.8c-1.5,0.8-3.1,2.3-3.1,5.4v12.9c0,0,0,1.5,0.8,3.1c0.8,1.5,2.3,3.1,5.4,3.1
              h12.9c0,0,1.5,0,3.1-0.8c1.5-0.8,3.1-2.3,3.1-5.4V38.2c0,0,0-1.5-0.8-3.1c-0.8-1.5-2.3-3.1-5.4-3.1H41V32.2v0.1h12.9
              c3,0,4.4,1.5,5.2,2.9c0.4,0.7,0.6,1.5,0.6,2c0.1,0.6,0.1,0.9,0.1,0.9v12.9c0,3-1.5,4.4-2.9,5.2c-0.7,0.4-1.5,0.6-2,0.6
              C54.3,57,53.9,57,53.9,57H41c-3,0-4.4-1.5-5.2-2.9c-0.4-0.7-0.6-1.5-0.6-2c-0.1-0.6-0.1-0.9-0.1-0.9V38.2c0-3,1.5-4.4,2.9-5.2
              c0.7-0.4,1.5-0.6,2-0.6c0.6-0.1,0.9-0.1,0.9-0.1V32.2L41,32.2z"/>
            <path d="M27.4,33.2V10.9h2.5c4.9,0,6.1,0.9,7,5.5h0.7l-0.2-7h-24l-0.2,7h0.7c1-4.6,2.2-5.5,7-5.5h2.5v21.8c0,3.3-0.2,4.4-4.1,4.6
              v0.4h12.2v-0.4C27.9,37.2,27.4,36.2,27.4,33.2L27.4,33.2z"/>
            <path d="M42.2,45.2h10.5c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H42.2c-0.3,0-0.5,0.2-0.5,0.5C41.6,44.9,41.9,45.2,42.2,45.2"
            />
            <path d="M46.9,39.4v10.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5V39.4c0-0.3-0.2-0.5-0.5-0.5C47.2,38.8,46.9,39.1,46.9,39.4"
            />
          </g>
          </svg>
      </span>
    )
  }
}


export class IconFontBold extends Component{
  render(){
    return(
      <span className={"Icons IconFontBold " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg
        x="0px" y="0px" viewBox="0 0 53.5 60">
<g>
	<path d="M0,60h28.6c7.5,0,13.6-1.5,18.1-4.6c4.5-3,6.8-7,6.8-11.9c0-5.3-2.4-9.4-7.1-12.3c-2.4-1.5-5.3-2.6-8.6-3.2v-0.8
		c3.1-0.6,6-1.9,8.7-4.1c2.7-2.2,4-5.1,4-8.7c0-6-3.3-10.2-9.9-12.5C37.1,0.6,32.7,0,27.4,0H0v2.3c2.6,0.1,4.3,0.5,5.3,1
		C7,4.2,7.8,5.9,7.8,8.5v43c0,2.6-0.9,4.4-2.6,5.3c-1,0.5-2.8,0.9-5.2,1V60L0,60z M22,26.9V7c0-1.6,0.4-2.7,1.1-3.4
		c0.7-0.6,2-0.9,3.9-0.9c3.5,0,5.9,1.2,7.1,3.5c1.2,2.3,1.8,5.2,1.8,8.5c0,4.6-0.9,7.7-2.8,9.5C31.2,26,27.5,26.9,22,26.9L22,26.9
		L22,26.9z M22,51.8V29.6c4.8-0.1,8.4,0.5,10.6,1.8c3.7,2.1,5.6,6.3,5.6,12.6c0,4.2-0.8,7.5-2.5,9.8C34,56,31,57.1,26.8,57.1
		c-2.1,0-3.4-0.6-4.2-1.9C22.2,54.5,22,53.4,22,51.8L22,51.8L22,51.8z"/>
</g>
</svg>
      </span>
    )
  }
}



export class IconFontItalic extends Component{
  render(){
    return(
      <span className={"Icons IconFontItalic " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg
        x="0px" y="0px" viewBox="0 0 36.2 60" >
        <g>
          <path d="M0,60h22.6v-1.5c-2.1-0.1-3.6-0.4-4.7-0.9c-1.1-0.5-1.6-1.5-1.6-3c0-0.5,0.1-1.2,0.2-2.1c0.2-0.9,0.4-2.1,0.8-3.5L28.6,8.3
            c0.8-2.8,1.6-4.5,2.5-5.2c0.9-0.7,2.6-1.2,5-1.5V0H13.4v1.5c2.4,0.2,4.1,0.5,5.1,1.1c1,0.6,1.4,1.6,1.4,3c0,0.7-0.1,1.3-0.2,2
            c-0.2,0.7-0.4,1.8-0.9,3.5L7.5,51.7c-0.8,2.8-1.8,4.7-3.1,5.6c-0.8,0.6-2.3,1-4.4,1.2V60L0,60z"/>
        </g>
        </svg>
      </span>
    )
  }
}




export class IconFontUnderline extends Component{
  render(){
    return(
      <span className={"Icons IconFontUnderline " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg x="0px" y="0px" viewBox="0 0 53 60" >
        <line fill="none" stroke="#000000" strokeWidth="3.021" x1="2.4" y1="58.5" x2="50.6" y2="58.5"/>
        <path d="M53,0H35.2v1.5c5.4,0.3,7.2,1.6,7.2,9.8V32c0,6.2-0.8,8.7-1.8,10.4c-2.2,3.6-6.6,6.1-12.6,6.1c-13.3,0-13.3-10.7-13.3-15.6
          V8.4c0-5.4,0.9-6.4,7-6.9V0H0v1.5c5.8,0.4,6.9,1.2,6.9,6.9v23.9c0,4.6,0,19.6,19,19.6c19.9,0,19.9-14.4,19.9-20.6v-20
          c0-8.1,1.3-9.2,7.2-9.8V0L53,0z"/>
        </svg>

      </span>
    )
  }
}



export class IconFontLeft extends Component{
  render(){
    return(
      <span className={"Icons IconFontLeft " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg
          x="0px" y="0px" viewBox="0 0 60 48.3">
        <path fill="none" stroke="#000000" strokeWidth="2.8765" strokeLinecap="round" strokeLinejoin="round" d="M1.4,1.4H39 M1.4,16.4
          h46.9 M1.4,31.7H39 M1.4,46.9h57.1"/>
        </svg>
      </span>
    )
  }
}



export class IconFontCenter extends Component{
  render(){
    return(
      <span className={"Icons IconFontCenter " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg  x="0px" y="0px" viewBox="0 0 60 48.3" >
          <path fill="none" stroke="#000000" strokeWidth="2.8765" strokeLinecap="round" strokeLinejoin="round" d="M16,1.4h28 M6.6,16.4
          h46.7 M14.4,31.7h31.2 M1.4,46.9h57.1"/>
        </svg>
      </span>
    )
  }
}


export class IconFontRight extends Component{
  render(){
    return(
      <span className={"Icons IconFontRight " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60 48.3" >
          <path fill="none" stroke="#000000" strokeWidth="2.8765" strokeLinecap="round" strokeLinejoin="round" d="M58.6,1.4H21
           M58.6,16.4H11.7 M58.6,31.7H21 M58.6,46.9H1.4"/>
        </svg>
      </span>
    )
  }
}


export class IconFontSize extends Component{
  render(){
    return(
      <span className={"Icons IconFontSize " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg  x="0px" y="0px" viewBox="0 0 60 47.6">
      <g>
        <path d="M42.7,40V2.4H47c8.3,0,10.4,1.6,11.9,9.3H60L59.6,0H19.1l-0.4,11.7h1.1c1.6-7.8,3.7-9.3,11.9-9.3h4.3v36.8
          c0,5.5-0.3,7.3-6.9,7.7v0.7h20.6v-0.7C43.7,46.6,42.7,45.1,42.7,40L42.7,40z"/>
        <path d="M13.4,41.5V20.6h2.4c4.6,0,5.8,0.9,6.6,5.2H23l-0.2-6.5H0.2L0,25.8h0.6c0.9-4.3,2-5.2,6.6-5.2h2.4v20.5
          c0,3.1-0.2,4.1-3.8,4.3v0.4h11.5v-0.4C13.9,45.2,13.4,44.4,13.4,41.5L13.4,41.5z"/>
      </g>
      </svg>
      </span>
    )
  }
}



export class IconFontSpace extends Component{
  render(){
    return(
      <span className={"Icons IconFontSpace " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 52.5 58.1" >
        <g>
          <line fill="none" stroke="#000000" strokeWidth="2" x1="6.9" y1="54.2" x2="45.6" y2="54.2"/>
          <path d="M0,54.2l10.7,3.9c0,0-3.8-3.9,0-7.8L0,54.2"/>
          <path d="M52.5,54.2l-10.7-3.9c0,0,3.8,3.9,0,7.8L52.5,54.2"/>
          <path d="M40.4,31.9L26.4,0h-0.7L13.9,27.8c-1.1,2.6-2.8,6.4-4.1,7.8c-1,1-1.9,1.2-2.8,1.3v0.5h10.6V37c-1.3,0-3.8-0.2-3.8-2.7
            c0-0.6,0.2-1.5,0.5-2.3l2.7-6.8h15.2l2.4,5.6c0.2,0.4,1.1,2.6,1.1,3.7c0,2.3-2.1,2.5-4,2.5v0.4h13.8v-0.5
            C43,36.7,42.1,35.8,40.4,31.9L40.4,31.9z M17.6,23.5l7-16.6l7,16.6H17.6L17.6,23.5z"/>
        </g>
        </svg>

      </span>
    )
  }
}

export class IconClone extends Component{
  render(){
    return(
      <span className={"Icons IconClone " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg  x="0px" y="0px" viewBox="0 0 55.6 60" >
      <path fill="none" stroke="#000000" strokeWidth="1.9766" d="M38.3,8c-0.5-2.6-2.3-7-8.6-7H9.8C9.8,1,1,1,1,9.8v30.9
        c0,0,0,8.8,8.8,8.8h5.1 M25.9,10.5c0,0-8.8,0-8.8,8.8v30.9c0,0,0,8.8,8.8,8.8h19.9c0,0,8.8,0,8.8-8.8V19.3c0,0,0-8.8-8.8-8.8H25.9
        L25.9,10.5z"/>
      </svg>
      </span>
    )
  }
}


export class IconLayerUp extends Component{
  render(){
    return(
      <span className={"Icons IconLayerUp " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 52.8" >
        <polygon fill="none" stroke="#141414" strokeWidth="1.7062" strokeLinecap="round" strokeLinejoin="round" points="29.2,0.9
          0.9,17 29.2,33.1 57.6,17 29.2,0.9 "/>
        <path fill="none" stroke="#CCCCCC" strokeWidth="1.7062" strokeLinecap="round" strokeLinejoin="round" d="M0.9,27.8l28.4,14.7
          l28.4-14.7 M0.9,37.2L29.2,52l29.9-15.6"/>
        </svg>
      </span>
    )
  }
}



export class IconLayerDonw extends Component{
  render(){
    return(
      <span className={"Icons IconLayerUp " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 53.4" >
        <path fill="none" stroke="#CCCCCC" strokeWidth="1.7258" strokeLinecap="round" strokeLinejoin="round" d="M29.6,0.9L0.9,17.2
          l28.7,16.3l28.7-16.3L29.6,0.9L29.6,0.9z M0.9,28.1L29.6,43l28.7-14.9"/>
        <polyline fill="none" stroke="#000000" strokeWidth="1.7258" strokeLinecap="round" strokeLinejoin="round" points="0.9,37.7
          29.6,52.6 59.1,36.8 "/>
        </svg>
      </span>
    )
  }
}



export class IconPipette extends Component{
  render(){
    return(
      <span className={"Icons IconLayerUp " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg x="0px" y="0px" viewBox="0 0 49.6 49.6">
      <path fill="none" stroke="#000000" strokeWidth="2.3" strokeMiterlimit="10" d="M35.7,24.9l-11-11c-0.3-0.3-0.3-0.9,0-1.3l3.4-3.4
        c0.3-0.3,0.9-0.3,1.3,0l11,11c0.3,0.3,0.3,0.9,0,1.3L37,24.9C36.6,25.2,36.1,25.2,35.7,24.9z"/>
      <path fill="none" stroke="#000000" strokeWidth="2.3" strokeMiterlimit="10" d="M38,17.8l-6.2-6.2c-0.4-0.4-0.4-1.1,0-1.6l7.3-7.3
        c2.1-2.1,5.6-2.1,7.8,0l0,0c2.1,2.1,2.1,5.6,0,7.8l-7.3,7.3C39.1,18.2,38.4,18.2,38,17.8z"/>
      <path fill="none" stroke="#000000" strokeWidth="2.3" strokeMiterlimit="10" d="M32.6,23L11.1,44.5C10.2,45.5,9,46.1,7.7,46
        c-1.7-0.1-4.9,3.5-6.2,2.2c-1.3-1.3,2.3-4.5,2.2-6.2c-0.1-1.3,0.5-2.6,1.4-3.5l21.5-21.5"/>
      </svg>

      </span>
    )
  }
}



export class IconFacebook extends Component{
  render(){
    return(
      <span className={"Icons IconFacebook " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg x="0px" y="0px" viewBox="0 0 60.1 60.1">
        <g>
          <path d="M25.3,49.4h7.9V29.7h5.5l0.6-6.6h-6.1c0,0,0-2.5,0-3.8c0-1.6,0.3-2.2,1.8-2.2c1.2,0,4.3,0,4.3,0v-6.9c0,0-4.5,0-5.5,0
            c-5.9,0-8.5,2.6-8.5,7.5c0,4.3,0,5.3,0,5.3h-4.1v6.7h4.1V49.4L25.3,49.4z"/>
          <path fill="none" stroke="#000000" strokeWidth="1.0012" d="M30,59.6c16.3,0,29.5-13.2,29.5-29.5C59.6,13.7,46.3,0.5,30,0.5
            C13.7,0.5,0.5,13.7,0.5,30C0.5,46.3,13.7,59.6,30,59.6L30,59.6z"/>
        </g>
        </svg>
      </span>
    )
  }
}



export class IconInstagram extends Component{
  render(){
    return(
      <span className={"Icons IconInstagram " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60.1 60.1">
        <path d="M30,15.1c4.8,0,5.3,0,7.2,0.1c1.7,0.1,2.7,0.4,3.3,0.6c0.8,0.3,1.4,0.7,2,1.3c0.6,0.6,1,1.2,1.3,2c0.2,0.6,0.5,1.6,0.6,3.3
          c0.1,1.9,0.1,2.4,0.1,7.2c0,4.8,0,5.3-0.1,7.2c-0.1,1.7-0.4,2.7-0.6,3.3c-0.3,0.8-0.7,1.4-1.3,2c-0.6,0.6-1.2,1-2,1.3
          c-0.6,0.2-1.6,0.5-3.3,0.6c-1.9,0.1-2.4,0.1-7.2,0.1c-4.8,0-5.3,0-7.2-0.1c-1.7-0.1-2.7-0.4-3.3-0.6c-0.8-0.3-1.4-0.7-2-1.3
          c-0.6-0.6-1-1.2-1.3-2c-0.2-0.6-0.5-1.6-0.6-3.3c-0.1-1.9-0.1-2.4-0.1-7.2c0-4.8,0-5.3,0.1-7.2c0.1-1.7,0.4-2.7,0.6-3.3
          c0.3-0.8,0.7-1.4,1.3-2c0.6-0.6,1.2-1,2-1.3c0.6-0.2,1.6-0.5,3.3-0.6C24.7,15.1,25.2,15.1,30,15.1 M30,11.9c-4.8,0-5.4,0-7.3,0.1
          c-1.9,0.1-3.2,0.4-4.3,0.8c-1.2,0.5-2.2,1.1-3.2,2.1c-1,1-1.6,2-2.1,3.2c-0.4,1.1-0.7,2.4-0.8,4.3c-0.1,1.9-0.1,2.5-0.1,7.3
          c0,4.8,0,5.4,0.1,7.3c0.1,1.9,0.4,3.2,0.8,4.3c0.5,1.2,1.1,2.2,2.1,3.2c1,1,2,1.6,3.2,2.1c1.1,0.4,2.4,0.7,4.3,0.8
          c1.9,0.1,2.5,0.1,7.3,0.1c4.8,0,5.4,0,7.3-0.1c1.9-0.1,3.2-0.4,4.3-0.8c1.2-0.5,2.2-1.1,3.2-2.1c1-1,1.6-2,2.1-3.2
          c0.4-1.1,0.7-2.4,0.8-4.3c0.1-1.9,0.1-2.5,0.1-7.3c0-4.8,0-5.4-0.1-7.3c-0.1-1.9-0.4-3.2-0.8-4.3c-0.5-1.2-1.1-2.2-2.1-3.2
          c-1-1-2-1.6-3.2-2.1c-1.1-0.4-2.4-0.7-4.3-0.8C35.4,11.9,34.8,11.9,30,11.9"/>
        <path d="M30,20.5c-5,0-9.1,4.1-9.1,9.1c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1C39.1,24.6,35,20.5,30,20.5 M30,35.6
          c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9c3.3,0,5.9,2.7,5.9,5.9C35.9,32.9,33.3,35.6,30,35.6"/>
        <path d="M41.6,20.2c0,1.2-1,2.1-2.1,2.1c-1.2,0-2.1-1-2.1-2.1c0-1.2,1-2.1,2.1-2.1C40.7,18,41.6,19,41.6,20.2"/>
        <path fill="none" stroke="#000000" strokeWidth="1.0012" d="M30,59.6c16.3,0,29.5-13.2,29.5-29.5C59.6,13.7,46.3,0.5,30,0.5
          C13.7,0.5,0.5,13.7,0.5,30C0.5,46.3,13.7,59.6,30,59.6L30,59.6z"/>
        </svg>
      </span>
    )
  }
}



export class IconArrowCircle extends Component{
  render(){
    return(
      <span className={"Icons IconArrowCircle " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 60 60">
        <path fill="none" stroke="#000000" strokeWidth="2.3255" d="M58.8,30C58.8,14.1,45.9,1.2,30,1.2C14.1,1.2,1.2,14.1,1.2,30
          c0,15.9,12.9,28.8,28.8,28.8C45.9,58.8,58.8,45.9,58.8,30L58.8,30z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.3255" strokeLinecap="round" d="M46.4,36.8L34,24.3c0,0-4-4-8,0L13.6,36.8"/>
        </svg>
      </span>
    )
  }
}



export class IconFitToMax extends Component{
  render(){
    return(
      <span className={"Icons IconFitToMax " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 60 60" >
          <g>
            <path fill="none" stroke="#141414" strokeWidth="2.4111" d="M16.6,30c0,7.4,6,13.4,13.4,13.4c7.4,0,13.4-6,13.4-13.4
              c0-7.4-6-13.4-13.4-13.4C22.6,16.6,16.6,22.6,16.6,30L16.6,30z"/>
            <path fill="none" stroke="#000000" strokeWidth="2.4111" d="M11,11l9.9,9.9 M39.1,39.1L49,49"/>
            <path fill="none" stroke="#000000" strokeWidth="2.4111" d="M49,11l-9.9,9.9 M20.9,39.1L11,49"/>
            <polygon points="4.8,22.1 22.1,4.8 0,0 4.8,22.1 	"/>
            <polygon points="4.8,37.9 22.1,55.2 0,60 4.8,37.9 	"/>
            <polygon points="37.9,4.8 55.2,22.1 60,0 37.9,4.8 	"/>
            <polygon points="37.9,55.2 55.2,37.9 60,60 37.9,55.2 	"/>
          </g>
          </svg>
      </span>
    )
  }
}



export class IconCenter extends Component{
  render(){
    return(
      <span className={"Icons IconCenter " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60 60" >
          <path fill="#141414" d="M20.9,30c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1c0-5-4.1-9.1-9.1-9.1S20.9,25,20.9,30L20.9,30z"/>
          <path fill="none" stroke="#141414" strokeWidth="2.3668" d="M1.2,30c0,15.9,12.9,28.8,28.8,28.8c15.9,0,28.8-12.9,28.8-28.8
            S45.9,1.2,30,1.2C14.1,1.2,1.2,14.1,1.2,30L1.2,30z"/>
        </svg>
      </span>
    )
  }
}


export class IconCrop extends Component{
  render(){
    return(
      <span className={"Icons IconCrop " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 54.4 59" >
        <path fill="none" stroke="#141414" strokeWidth="1.855" d="M54.4,9.9h-46V59 M41.2,0c0,2.7,0,5.3,0,5.3 M0,45.6c3.4,0,4.9,0,4.9,0
           M41.1,14.7V46H12.3"/>
        </svg>
      </span>
    )
  }
}


export class IconFlipVertical extends Component{
  render(){
    return(
      <span className={"Icons IconFlipVertical " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60 49" >
        <path fill="none" stroke="#141414" strokeWidth="1.8783" d="M60,24.2c-3,0-60,0-60,0"/>
        <polyline fill="#141414" points="53.8,0 30.2,21.2 6.7,0 "/>
        <polygon fill="none" stroke="#141414" strokeWidth="1.8783" points="50.5,46.4 30.9,27.9 30.2,27.3 29.6,27.9 9.9,46.4 8.2,48
          10.6,48 49.9,48 52.3,48 50.5,46.4 "/>
        </svg>
      </span>
    )
  }
}


export class IconFlipHorizontal extends Component{
  render(){
    return(
      <span className={"Icons IconFlipHorizontal " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 49 60" >
        <path fill="none" stroke="#141414" strokeWidth="1.8783" d="M24.8,60c0-3,0-60,0-60"/>
        <polyline fill="#141414" points="49,53.8 27.7,30.2 49,6.7 "/>
        <polygon fill="none" stroke="#141414" strokeWidth="1.8783" points="2.6,50.5 21,30.9 21.6,30.2 21,29.6 2.6,9.9 0.9,8.2 0.9,10.6
          0.9,49.9 0.9,52.3 2.6,50.5 "/>
        </svg>
      </span>
    )
  }
}


export class IconRotateRight extends Component{
  render(){
    return(
      <span className={"Icons IconRotateRight " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 53.1" >
        <polygon points="43.1,53.1 60,47.1 40,35.5 43.1,53.1 "/>
        <path fill="none" stroke="#000000" strokeWidth="2.2713" strokeLinecap="round" d="M47.8,45.2l2.5-4.5c7.3-12.6,3-28.7-9.7-36
          c-12.6-7.3-28.7-3-36,9.7c-7.3,12.6-3,28.7,9.7,36"/>
        </svg>
      </span>
    )
  }
}



export class IconBrightness extends Component{
  render(){
    return(
      <span className={"Icons IconBrightness " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 60 60" >
        <path fill="none" stroke="#000000" strokeWidth="2.8202" d="M30,52.2c12.3,0,22.2-9.9,22.2-22.2c0-12.3-9.9-22.2-22.2-22.2
          C17.7,7.8,7.8,17.7,7.8,30C7.8,42.3,17.7,52.2,30,52.2L30,52.2z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" d="M30,1.4v4.5 M58.6,30
          h-4.6"/>
        <line fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" x1="9.8" y1="9.8" x2="13.1" y2="13.1"/>
        <line fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" x1="50.2" y1="9.8" x2="46.9" y2="13.1"/>
        <line fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" x1="5.9" y1="30" x2="1.4" y2="30"/>
        <line fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" x1="47" y1="47" x2="50.2" y2="50.2"/>
        <line fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" x1="30" y1="54.1" x2="30" y2="58.6"/>
        <line fill="none" stroke="#000000" strokeWidth="2.8202" strokeLinecap="round" strokeLinejoin="round" x1="13" y1="47" x2="9.8" y2="50.2"/>
        </svg>
      </span>
    )
  }
}



export class IconContrast extends Component{
  render(){
    return(
      <span className={"Icons IconContrast " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <path fill="#FFFFFF" d="M30,58.4c15.7,0,28.4-12.7,28.4-28.4S45.7,1.6,30,1.6C14.3,1.6,1.6,14.3,1.6,30S14.3,58.4,30,58.4L30,58.4z"
        />
        <path fill="none" stroke="#000000" strokeWidth="3.2038" d="M30,58.4c15.7,0,28.4-12.7,28.4-28.4S45.7,1.6,30,1.6
          C14.3,1.6,1.6,14.3,1.6,30S14.3,58.4,30,58.4L30,58.4z"/>
        <path d="M29.9,58.4c15.7,0,28.4-12.7,28.4-28.4S45.6,1.6,29.9,1.6c0,0,0,13.1,0,26.7C30,44.5,29.9,58.4,29.9,58.4L29.9,58.4z"/>
        </svg>

      </span>
    )
  }
}



export class IconSaturation extends Component{
  render(){
    return(
      <span className={"Icons IconSaturation " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg  x="32px" y="32px" viewBox="0 0 59.1 60.3">
        <path fill="none" stroke="#000000" strokeWidth="6.9168" d="M30.2,4.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6
	c-0.3,0-0.6,0.3-0.6,0.6S29.8,4.6,30.2,4.6L30.2,4.6z"/>
        <path fill="none" stroke="#000000" strokeWidth="4.4016" d="M30.2,58.1c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6
	c-0.3,0-0.6,0.3-0.6,0.6C29.6,57.9,29.8,58.1,30.2,58.1L30.2,58.1z"/>
        <path fill="none" stroke="#000000" strokeWidth="3.144" d="M56.3,30.8c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6
	s-0.3-0.6-0.6-0.6C56.6,30.2,56.3,30.5,56.3,30.8L56.3,30.8z"/>
        <path fill="none" stroke="#000000" strokeWidth="5.6592" d="M2.8,30.8c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6
	s-0.3-0.6-0.6-0.6C3.1,30.2,2.8,30.5,2.8,30.8L2.8,30.8z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.5152" d="M48.7,12.3c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.2-0.6,0-0.8
	c-0.2-0.2-0.6-0.2-0.8,0C48.5,11.7,48.5,12.1,48.7,12.3L48.7,12.3z"/>
        <path fill="none" stroke="#000000" strokeWidth="5.0304" d="M10.8,50.1c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.2-0.6,0-0.8
	c-0.2-0.2-0.6-0.2-0.8,0C10.6,49.5,10.6,49.9,10.8,50.1L10.8,50.1z"/>
        <path fill="none" stroke="#000000" strokeWidth="3.7728" d="M48.7,49.3c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0
	c0.2-0.2,0.2-0.6,0-0.8C49.3,49.1,48.9,49.1,48.7,49.3L48.7,49.3z"/>
        <path fill="none" stroke="#000000" strokeWidth="6.288" d="M10.8,11.5c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0
	c0.2-0.2,0.2-0.6,0-0.8C11.4,11.2,11.1,11.2,10.8,11.5L10.8,11.5z"/>
      </svg>
      </span>


    )
  }
}



export class IconBlur extends Component{
  render(){
    return(
      <span className={"Icons IconBlur " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
      <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <path fill="none" stroke="#000000" strokeWidth="2.6388" d="M30,2.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6
          c-0.3,0-0.6,0.3-0.6,0.6C29.4,2.3,29.7,2.5,30,2.5L30,2.5z M30,58.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6
          c-0.3,0-0.6,0.3-0.6,0.6C29.4,58.4,29.7,58.7,30,58.7L30,58.7z M57.5,30c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6
          c0-0.3-0.3-0.6-0.6-0.6C57.7,29.4,57.5,29.7,57.5,30L57.5,30z M1.3,30c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6
          c0-0.3-0.3-0.6-0.6-0.6C1.6,29.4,1.3,29.7,1.3,30L1.3,30z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6389" d="M49.4,10.6c0.2,0.2,0.6,0.2,0.9,0c0.2-0.2,0.2-0.6,0-0.9
          c-0.2-0.2-0.6-0.2-0.9,0C49.2,10,49.2,10.3,49.4,10.6L49.4,10.6z M9.7,50.3c0.2,0.2,0.6,0.2,0.9,0c0.2-0.2,0.2-0.6,0-0.9
          c-0.2-0.2-0.6-0.2-0.9,0C9.5,49.7,9.5,50,9.7,50.3L9.7,50.3z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6389" d="M49.4,49.4c-0.2,0.2-0.2,0.6,0,0.9c0.2,0.2,0.6,0.2,0.9,0
          c0.2-0.2,0.2-0.6,0-0.9C50,49.2,49.7,49.2,49.4,49.4L49.4,49.4z M9.7,9.7c-0.2,0.2-0.2,0.6,0,0.9c0.2,0.2,0.6,0.2,0.9,0
          c0.2-0.2,0.2-0.6,0-0.9C10.3,9.5,10,9.5,9.7,9.7L9.7,9.7z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6389" d="M19.5,4.6c0.3-0.1,0.5-0.5,0.3-0.8c-0.1-0.3-0.5-0.5-0.8-0.3
          c-0.3,0.1-0.5,0.5-0.3,0.8C18.8,4.6,19.2,4.7,19.5,4.6L19.5,4.6z M41,56.5c0.3-0.1,0.5-0.5,0.3-0.8c-0.1-0.3-0.5-0.5-0.8-0.3
          c-0.3,0.1-0.5,0.5-0.3,0.8C40.3,56.5,40.7,56.6,41,56.5L41,56.5z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6389" d="M55.4,19.5c0.1,0.3,0.5,0.5,0.8,0.3c0.3-0.1,0.5-0.5,0.3-0.8
          c-0.1-0.3-0.5-0.5-0.8-0.3C55.4,18.8,55.3,19.2,55.4,19.5L55.4,19.5z M3.5,41c0.1,0.3,0.5,0.5,0.8,0.3c0.3-0.1,0.5-0.5,0.3-0.8
          c-0.1-0.3-0.5-0.5-0.8-0.3S3.4,40.7,3.5,41L3.5,41z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6389" d="M40.5,4.6c0.3,0.1,0.7,0,0.8-0.3c0.1-0.3,0-0.7-0.3-0.8
          c-0.3-0.1-0.7,0-0.8,0.3C40.1,4.1,40.2,4.5,40.5,4.6L40.5,4.6z M19,56.5c0.3,0.1,0.7,0,0.8-0.3c0.1-0.3,0-0.7-0.3-0.8
          c-0.3-0.1-0.7,0-0.8,0.3C18.6,56,18.7,56.4,19,56.5L19,56.5z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6389" d="M55.4,40.5c-0.1,0.3,0,0.7,0.3,0.8c0.3,0.1,0.7,0,0.8-0.3
          c0.1-0.3,0-0.7-0.3-0.8C55.9,40.1,55.5,40.2,55.4,40.5L55.4,40.5z M3.5,19c-0.1,0.3,0,0.7,0.3,0.8c0.3,0.1,0.7,0,0.8-0.3
          c0.1-0.3,0-0.7-0.3-0.8C4,18.6,3.6,18.7,3.5,19L3.5,19z"/>
        <path fill="#FFFFFF" d="M30,49.1c10.6,0,19.1-8.6,19.1-19.1c0-10.6-8.6-19.1-19.1-19.1c-10.6,0-19.1,8.6-19.1,19.1
          C10.9,40.6,19.4,49.1,30,49.1L30,49.1z"/>
        <path fill="none" stroke="#000000" strokeWidth="2.6339" d="M30,49.1c10.6,0,19.1-8.6,19.1-19.1c0-10.6-8.6-19.1-19.1-19.1
          c-10.6,0-19.1,8.6-19.1,19.1C10.9,40.6,19.4,49.1,30,49.1L30,49.1z"/>
        </svg>

      </span>
    )
  }
}


export class IconRotateLeft extends Component{
  render(){
    return(
      <span className={"Icons IconRotateLeft " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 59.1 50.5" >
        <polygon points="7,31.8 0,16.9 20.5,22.4 7,31.8 "/>
        <path fill="none" stroke="#000000" strokeWidth="3.473" strokeLinecap="round" d="M9.9,23.5l1.3-4.4c3.3-12.5,16.2-20,28.8-16.6
          c12.5,3.4,20,16.3,16.6,28.8c-3.3,12.5-16.2,20-28.8,16.6"/>
        </svg>

      </span>
    )
  }
}


export class IconUpload extends Component{
  render(){
    return(
      <span className={"Icons IconUpload " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg  x="0px" y="0px" viewBox="0 0 52.8 60" >
        <path fill="none" stroke="#000000" strokeWidth="2.381" strokeLinecap="round" strokeLinejoin="round" d="M16.5,23.3H1.2v35.5
          h50.4V23.3H36.3 M26.4,1.5v39.1"/>
        <polyline fill="none" stroke="#000000" strokeWidth="2.381" strokeLinecap="round" strokeLinejoin="round" points="38.6,13.4
          26.4,1.2 14.2,13.4 "/>
        </svg>
      </span>
    )
  }
}


export class IconOpacity extends Component{
  render(){
    return(
      <span className={"Icons IconOpacity " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <g>
          <polygon fill="#FFFFFF" points="60,12 60,24 48,24 48,12 60,12 	"/>
          <polygon fill="#FFFFFF" points="60,36 60,48 48,48 48,36 60,36 	"/>
          <polygon fill="#FFFFFF" points="12,0 12,12 24,12 24,0 12,0 	"/>
          <polygon fill="#FFFFFF" points="12,48 12,60 24,60 24,48 12,48 	"/>
          <polygon fill="#FFFFFF" points="12,24 12,36 24,36 24,24 12,24 	"/>
          <polygon fill="#FFFFFF" points="36,12 36,24 24,24 24,12 36,12 	"/>
          <polygon fill="#FFFFFF" points="36,36 36,48 24,48 24,36 36,36 	"/>
          <polygon fill="#FFFFFF" points="36,0 36,12 48,12 48,0 36,0 	"/>
          <polygon fill="#FFFFFF" points="36,48 36,60 48,60 48,48 36,48 	"/>
          <polygon fill="#FFFFFF" points="36,24 36,36 48,36 48,24 36,24 	"/>
          <polygon fill="#FFFFFF" points="12,12 12,24 0,24 0,12 12,12 	"/>
          <polygon fill="#FFFFFF" points="12,36 12,48 0,48 0,36 12,36 	"/>
          <polygon fill="#919494" points="0,0 0,12 12,12 12,0 0,0 	"/>
          <polygon fill="#919494" points="0,48 0,60 12,60 12,48 0,48 	"/>
          <polygon fill="#919494" points="0,24 0,36 12,36 12,24 0,24 	"/>
          <polygon fill="#919494" points="48,12 48,24 36,24 36,12 48,12 	"/>
          <polygon fill="#919494" points="48,36 48,48 36,48 36,36 48,36 	"/>
          <polygon fill="#919494" points="24,0 24,12 36,12 36,0 24,0 	"/>
          <polygon fill="#919494" points="24,48 24,60 36,60 36,48 24,48 	"/>
          <polygon fill="#919494" points="24,24 24,36 36,36 36,24 24,24 	"/>
          <polygon fill="#919494" points="24,12 24,24 12,24 12,12 24,12 	"/>
          <polygon fill="#919494" points="24,36 24,48 12,48 12,36 24,36 	"/>
          <polygon fill="#919494" points="48,0 48,12 60,12 60,0 48,0 	"/>
          <polygon fill="#919494" points="48,48 48,60 60,60 60,48 48,48 	"/>
          <polygon fill="#919494" points="48,24 48,36 60,36 60,24 48,24 	"/>
        </g>
        </svg>
      </span>
    )
  }
}


export class IconMenu extends Component{
  render(){
    return(
      <span className={"Icons IconMenu " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <span>
          <img src="dist/icons/IconsCreator-NonActive20.png"/>
          <img src="dist/icons/IconsCreator-NonActive20.png"/>
        </span>
         <span>
          <img src="dist/icons/IconsCreator-Active20.png"/>
          <img src="dist/icons/IconsCreator-Active20.png"/>
        </span>
      </span>
    )
  }
}


export class IconSettings extends Component{
  render(){
    return(
      <span className={"Icons IconSettings " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg x="0px" y="0px" viewBox="0 0 60.4 60" >
          <path fill="none" stroke="#000000" strokeWidth="1.2366" d="M41.9,24.2 M37.7,23.6l10.2-10.2l0,0l1.3-0.3c0,0,1.3-0.3,3.2-3
            l5.3-7.6l0,0l-1.2-1.2L56,0.7c0,0-0.6-0.6-3.3,1.3L45,7.4l0,0l-0.3,1.3c0,0-0.3,1.3-2.6,3.6l-7.8,7.8 M27,42.6c0,0-8,8-11.8,11.7
            c-4.3,4.3-8.8,4.1-12.1,0.8C-0.2,51.9-0.5,47.5,4,43c3.7-3.7,11.8-11.7,11.8-11.7"/>
          <path fill="none" stroke="#000000" strokeWidth="0.8244" d="M22.3,38.2c0,0-11.6,11.9-12.9,13.3c-1.4,1.4-2.2,0.6-2.5,0.2
            c-0.4-0.4-1.4-1.4-0.2-2.5C7.8,48,19.9,35.9,19.9,35.9"/>
          <path fill="none" stroke="#000000" strokeWidth="1.2366" d="M1.9,8.7c-0.2,2.5,1.4,4.5,2.9,6.1c1.6,1.6,27.6,27.6,27.6,27.6
            s2.4,2.3,2,4.5c0,0-0.4,1-0.4,2.2c0,1.2,0,1.6,1,2.5c1,1,5.5,5.5,6.3,6.3c0.8,0.8,1.8,1.8,3.1,1.6c1.4-0.2,3.8-0.9,3.8-0.9
            s2.4-0.7,0.1-3c0,0-3.7-3.7-4.5-4.5c-0.8-0.8-1-2.2-0.4-2.7c0.6-0.6,2.5-2.5,2.5-2.5s2-2,2.5-2.5c0.6-0.6,2-0.4,2.7,0.4
            c0.8,0.8,4.5,4.5,4.5,4.5s2.4,2.3,3.1-0.8c0,0,0.6-1.8,0.8-3.1c0.2-1.4-0.8-2.3-1.6-3.1c-0.8-0.8-5.3-5.3-6.3-6.3c-1-1-1.4-1-2.5-1
            c-1.2,0-2.7,0.4-2.7,0.4s-1.6,0.4-3.9-2c0,0-26-26-27.6-27.6C13.5,3,11.5,1.4,9,1.6C6.4,1.8,5.5,2.4,4.1,3.8
            C2.7,5.2,2.1,6.1,1.9,8.7L1.9,8.7z"/>
          <path d="M7.4,7C6,8.5,6,10.8,7.4,12.3c1.5,1.5,3.8,1.5,5.3,0c1.5-1.5,1.5-3.8,0-5.3C11.3,5.6,8.9,5.6,7.4,7L7.4,7z"/>
          </svg>
   </span>

    )
  }
}


export class IconMobile extends Component{
  render(){
    return(
      <span className={"Icons IconMobile " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg x="0px" y="0px" viewBox="0 0 34.6 60" >
        <g>
          <path fill="none" stroke="#000000" strokeWidth="1.1365" d="M5.3,0.6c0,0-4.7,0-4.7,4.7v49.4c0,0,0,4.7,4.7,4.7h24
            c0,0,4.7,0,4.7-4.7V5.3c0,0,0-4.7-4.7-4.7H5.3L5.3,0.6z"/>
          <polygon points="7,4.6 7,4.6 7,6 7,6 28.6,6 28.6,6 28.6,4.6 28.6,4.6 7,4.6 	"/>
          <polygon fill="none" stroke="#000000" strokeWidth="1.1365" points="3.2,8.2 3.2,50.4 31.4,50.4 31.4,8.2 3.2,8.2 	"/>
          <path fill="none" stroke="#000000" strokeWidth="1.1365" d="M17.1,57.1c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7
            c-0.9,0-1.7,0.8-1.7,1.7C15.5,56.3,16.2,57.1,17.1,57.1L17.1,57.1z"/>
        </g>
        </svg>

      </span>
    )
  }
}


export class IconDesktop extends Component{
  render(){
    return(
      <span className={"Icons IconDesktop " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
     <svg x="0px" y="0px" viewBox="0 0 60.3 56" >
        <g>
          <path fill="none" stroke="#000000" strokeWidth="1.0745" d="M59.7,5.4c0,0,0-4.9-4.9-4.9H5.4c0,0-4.9,0-4.9,4.9v33.8
            c0,0,0,4.9,4.9,4.9h49.4c0,0,4.9,0,4.9-4.9V5.4L59.7,5.4z M57,6.8c0,0,0-1.1-1.1-1.1H4.4c0,0-1.1,0-1.1,1.1v31c0,0,0,1.1,1.1,1.1
            h51.5c0,0,1.1,0,1.1-1.1V6.8L57,6.8z M24.8,46.2c0,0-2,0-2.4,2l-0.9,5c0,0-0.4,2.2,1.9,2.2h13c0,0,2,0,1.6-2l-0.9-5
            c0,0-0.4-2.2-2.7-2.2H24.8L24.8,46.2z"/>
        </g>
      </svg>
      </span>
    )
  }
}



export class IconPanel extends Component{
  render(){
    return(
      <span className={"Icons IconPanel " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <g>
          <path fill="none" stroke="#000000" strokeWidth="1.2162" d="M59.4,1.9c0,0,0-1.3-1.3-1.3H1.9c0,0-1.3,0-1.3,1.3v56.2
            c0,0,0,1.3,1.3,1.3h56.2c0,0,1.3,0,1.3-1.3V1.9L59.4,1.9z"/>
          <polygon points="3.2,3.2 3.2,11.4 56.8,11.4 56.8,3.2 3.2,3.2 	"/>
        </g>
        </svg>
      </span>
    )
  }
}


export class IconPanelLeft extends Component{
  render(){
    return(
      <span className={"Icons IconPanelLeft " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
       <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <g>
          <path fill="none" stroke="#000000" strokeWidth="1.2162" d="M59.4,1.9c0,0,0-1.3-1.3-1.3H1.9c0,0-1.3,0-1.3,1.3v56.2
            c0,0,0,1.3,1.3,1.3h56.2c0,0,1.3,0,1.3-1.3V1.9L59.4,1.9z"/>
          <polygon points="3.2,3.2 3.2,11.4 56.8,11.4 56.8,3.2 3.2,3.2 	"/>
        </g>
        </svg>
      </span>
    )
  }
}


export class IconPanelRight extends Component{
  render(){
    return(
      <span className={"Icons IconPanelRight " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <g>
          <path fill="none" stroke="#000000" strokeWidth="1.2162" d="M59.4,1.9c0,0,0-1.3-1.3-1.3H1.9c0,0-1.3,0-1.3,1.3v56.2
            c0,0,0,1.3,1.3,1.3h56.2c0,0,1.3,0,1.3-1.3V1.9L59.4,1.9z"/>
          <polygon points="3.2,3.2 3.2,11.4 56.8,11.4 56.8,3.2 3.2,3.2 	"/>
        </g>
        </svg>
      </span>
    )
  }
}


export class IconPanelBottom extends Component{
  render(){
    return(
      <span className={"Icons IconPanelBottom " + ( this.props.size ? this.props.size+'Icons ' : '' ) + (this.props.active ? 'IconsActive ' : ' ') + (this.props.hover ? 'IconsHover ' : ' ') }>
        <svg  x="0px" y="0px" viewBox="0 0 60 60" >
        <g>
          <path fill="none" stroke="#000000" strokeWidth="1.2162" d="M59.4,1.9c0,0,0-1.3-1.3-1.3H1.9c0,0-1.3,0-1.3,1.3v56.2
            c0,0,0,1.3,1.3,1.3h56.2c0,0,1.3,0,1.3-1.3V1.9L59.4,1.9z"/>
          <polygon points="3.2,3.2 3.2,11.4 56.8,11.4 56.8,3.2 3.2,3.2 	"/>
        </g>
        </svg>
      </span>
    )
  }
}


export class IconDrag extends Component{
  render(){
    return(
      <svg width="14" version="1.1" height="14" viewBox="0 0 64 64" ><path fill="#1D1D1B" d="m63.875 31.203c-0.102-0.246-0.248-0.467-0.435-0.652l-6.837-6.838c-0.783-0.783-2.051-0.783-2.834 0-0.781 0.781-0.781 2.05 0 2.832l3.42 3.42-23.16-0.001 0.002-23.155 3.568 3.57c0.393 0.392 0.904 0.588 1.418 0.588 0.512 0 1.025-0.196 1.416-0.588 0.783-0.781 0.783-2.051 0-2.834l-6.988-6.99c-0.186-0.186-0.406-0.332-0.652-0.434-0.49-0.203-1.041-0.203-1.531 0-0.244 0.101-0.463 0.246-0.646 0.429 0 0-0.002 0.002-0.004 0.003l-6.844 6.84c-0.781 0.783-0.781 2.051 0 2.834 0.393 0.391 0.904 0.587 1.418 0.587 0.512 0 1.025-0.196 1.416-0.587l3.422-3.42-0.002 23.157-23.15-0.001 3.417-3.418c0.781-0.782 0.781-2.051 0-2.832-0.783-0.783-2.051-0.783-2.834 0l-6.838 6.84c-0.393 0.391-0.588 0.903-0.588 1.416s0.195 1.025 0.588 1.417l6.988 6.989c0.392 0.393 0.904 0.588 1.417 0.588s1.025-0.195 1.417-0.588c0.782-0.783 0.782-2.051 0-2.833l-3.571-3.571 23.153 0.001-0.001 23.153-3.418-3.417c-0.783-0.78-2.051-0.782-2.834 0.001-0.781 0.783-0.781 2.052 0 2.834l6.844 6.839c0.391 0.392 0.904 0.587 1.416 0.587 0.513 0 1.025-0.195 1.416-0.587l6.99-6.991c0.783-0.783 0.783-2.053 0-2.834-0.783-0.783-2.051-0.783-2.834 0l-3.572 3.574 0.002-23.159 23.16 0.001-3.57 3.569c-0.781 0.782-0.781 2.05 0 2.833 0.393 0.393 0.904 0.588 1.418 0.588 0.512 0 1.025-0.195 1.416-0.588l6.989-6.989c0.004-0.005 0.006-0.012 0.012-0.017 0.177-0.182 0.321-0.396 0.421-0.633 0.102-0.246 0.154-0.506 0.154-0.768-0.001-0.259-0.053-0.52-0.155-0.765z"></path></svg>
    )}}

    /*
     <span>
     <img src="dist/icons/IconsCreator-NonActive46.png"/>
     <img src="dist/icons/IconsCreator-NonActive46png"/>
     </span>
     <span>
     <img src="dist/icons/IconsCreator-Active46.png"/>
     <img src="dist/icons/IconsCreator-Active46.png"/>
     </span>

     .str1 {stroke:black;strokeWidth:16.6063}
     .str0 {stroke:black;strokeWidth:16.6063;strokeLinecap:round;strokeLinejoin:round}
     .fil0 {fill:none;fill-rule:nonzero}

     <span>
     <img src="dist/icons/IconsCreator-NonActive6.png"/>
     <img src="dist/icons/IconsCreator-NonActive6.png"/>
     </span>
     <span>
     <img src="dist/icons/IconsCreator-Active6.png"/>
     <img src="dist/icons/IconsCreator-Active6.png"/>
     </span>

settings

     <span>
     <img src="dist/icons/IconsCreator-NonActive-update.png"/>
     <img src="dist/icons/IconsCreator-NonActive-update.png"/>
     </span>
     <span>
     <img src="dist/icons/IconsCreator-Active-update.png"/>
     <img src="dist/icons/IconsCreator-Active-update.png"/>
     </span>
     </span>

     */